import { LoadableLazy } from '@confluence/loadable';

export type { EditorInlineReactionsPubSubHandlerProps } from '../src/pubsub/EditorInlineReactionsPubSubHandler.tsx';

export const EditorInlineReactionsPubSubHandler = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-EditorInlineReactionsPubSubHandler" */ '../src/pubsub/EditorInlineReactionsPubSubHandler.tsx'
			)
		).EditorInlineReactionsPubSubHandler,
});
